import $ from 'jquery';
import select2 from '../../libs/select2';

$(document).ready(function () {
    // Payment form selects are handled by the gulpfile code
    if ($('#payment-form-page').length == 0) {

        function setAriaLabelledByValueFromParentID() {

            const episerverFormMainBody = document.querySelector('.Form__MainBody');

            if (episerverFormMainBody) {

                const select2 = document.querySelectorAll('.select2');

                select2.forEach((select) => {
                    const parent = select.parentElement;
                    const labelID = parent.querySelector('label')?.id;
                    const formSelect2Combobox = parent.querySelector('.select2-selection');
                    if (labelID) {
                        formSelect2Combobox.setAttribute('aria-labelledby', labelID);
                    }
                });
            }
        }

        $('.Form__MainBody select').each(function (index, elem) {
            var container = $(this).parents(".FormSelection");
            $(this).select2({
                minimumResultsForSearch: Infinity,
                dropdownParent: container
            }).on('select2:open', function (e) {
                document.body.classList.add('select2-dropdown-open');
            }).on('select2:close', function (e) {
                document.body.classList.remove('select2-dropdown-open');
                document.body.classList.remove('mouse-select2-hovered-over');

                const event = new CustomEvent('prevent-select2-scroll-on');
                document.dispatchEvent(event);
            }).on('select2:select', function (e) {
                document.body.classList.remove('select2-dropdown-open');
                document.body.classList.remove('mouse-select2-hovered-over');

                const event = new CustomEvent('prevent-select2-scroll-on');
                document.dispatchEvent(event);
            });

            setAriaLabelledByValueFromParentID();
        });

        $('.FormTextbox__Input, form.EPiServerForms ').prop("autocomplete", "chrome-off");

        
        // Detect when select is hovered over or not
        document.querySelectorAll('.FormSelection').forEach(select2Elem => {
            select2Elem.addEventListener('mouseover', (e) => {
                if (!e.target) return;

                const target = e.target.closest(".select2-dropdown");
                if (target) {
                    document.body.classList.add('mouse-select2-hovered-over');

                    const event = new CustomEvent('prevent-select2-scroll-off');
                    document.dispatchEvent(event);
                }
            });

            select2Elem.addEventListener('mouseout', (e) => {
                if (!e.target) return;

                const target = e.target.closest(".select2-dropdown");
                if (target) {
                    document.body.classList.remove('mouse-select2-hovered-over');

                    const event = new CustomEvent('prevent-select2-scroll-on');
                    document.dispatchEvent(event);
                }
            });
        });
    }
});